// @ts-nocheck
import { ShipmentStatusCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { getShipmentStatuses, GetShipmentStatusesApiParameter } from "@store/Framework/Services/ShipmentService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetShipmentStatusesApiParameter, ShipmentStatusCollectionModel>;

export const DispatchBeginLoadShipmentStatuses: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/ShipmentStatuses/BeginLoadShipmentStatuses",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getShipmentStatuses(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 403) {
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadShipmentStatuses: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/ShipmentStatuses/CompleteLoadShipmentStatuses",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    DispatchBeginLoadShipmentStatuses,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadShipmentStatuses,
];

const loadShipmentStatuses = createHandlerChainRunner(chain, "LoadShipmentStatuses");
export default loadShipmentStatuses;
